<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Documents</div><h2>Strata files</h2></div>
        </div>
        <section class="page-section">
            <el-form :inline="true" size="medium">
                <el-form-item label="Keywords">
                    <el-input size="medium" class="w300" prefix-icon="plus" :clearable="true" v-model="params.q"/>
                </el-form-item>
                <el-form-item label="Email Status">
                    <el-select size="medium" v-model="params.email_status" placeholder="Email Status" clearable>
                        <el-option label="No Email Address" value="no"/>
                        <el-option label="Email Address Distinct" value="distinct"/>
                        <el-option label="Email Duplicate" value="duplicate"/>
                        <el-option label="Pending" value="pending"/>
                        <el-option label="Sent" value="sent"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="Sent At">
                    <el-date-picker
                        v-model="params.date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="onSearch">Search</el-button>
                </el-form-item>
            </el-form>
        </section>
        <section class="page-section" v-loading="loading">
            <div class="tablenav tablenav-top">
                <el-button type="primary" size="small" @click="showUploader=true">
                    <i class="el-icon-upload"></i>
                    <span>Upload</span>
                </el-button>

                <el-button type="primary" size="small" @click="handleAddDir">
                    <i class="el-icon-folder-add"></i>
                    <span>Create a new folder</span>
                </el-button>
            </div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/buildium/association-files' }">All Files</el-breadcrumb-item>
                <el-breadcrumb-item
                    v-for="(path,index) in curDirPaths"
                    :key="index"
                    :to="{ path: '/buildium/association-files?dir=' + path.id }"
                >{{ path.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="curDir.id">{{ curDir.name }}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-table :data="dataList" @sort-change="onSortChange"
                      @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column label="Name" sortable="custom" prop="name">
                    <template slot-scope="scope">
                        <div class="file-name">
                            <img alt="folder" class="file-name-title__icon" :src="scope.row.icon">
                            <router-link :to="'/buildium/association-files?dir='+scope.row.id"
                                         class="file-name-title__text"
                                         v-if="scope.row.is_dir">
                                {{
                                    scope.row.name
                                }}
                            </router-link>
                            <a :href="scope.row.links.view.href" class="file-name-title__text" target="_blank"
                               v-else>{{ scope.row.name }}</a>
                            <div class="file-name-title__actions">
                                <a @click="handleEditDir(scope.row)"
                                   class="el-link el-link--primary el-icon-edit-outline"
                                   title="Edit" v-if="scope.row.is_dir"></a>
                                <a @click="handleMoveDir(scope.row)" class="el-link el-link--primary el-icon-rank"
                                   title="Move"></a>
                                <a @click="handleDownloadDir(scope.row)"
                                   class="el-link el-link--primary el-icon-download" title="Download"></a>
                                <a @click="handleExportDir(scope.row)" class="el-link el-link--primary el-icon-document"
                                   title="Export" v-if="scope.row.is_dir"></a>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Council Members" width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_dir">-</div>
                        <div v-else>
                            <el-popover
                                placement="bottom-start"
                                width="500"
                                trigger="hover"
                            >
                                <a slot="reference">{{ getFirstOwner(scope.row.to) }}</a>
                                <div v-for="owner in scope.row.to||[]">
                                    <a class="el-link text-break text-ellipsis" @click="handleShowEditOwner(owner)">
                                        <span>{{ owner.FirstName + ' ' + owner.LastName }}</span>
                                        <span><{{ owner.Email }}></span>
                                    </a>
                                </div>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Status" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_dir">-</div>
                        <div v-else>
                            <el-tag type="success" v-if="scope.row.status==='sent'">Sent</el-tag>
                            <el-tag type="warning" v-else>{{ scope.row.status }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="170" label="Sent At" sortable="custom" prop="sent_at">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_dir">-</div>
                        <div v-else>{{ scope.row.sent_at }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" align="right" width="100">
                    <template slot-scope="scope">
                        <a class="el-link el-link--primary" @click="onResend(scope.row)">Send</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-button-group>
                        <el-button @click="onBatchDelete" type="primary" :disabled="!selectionIds.length" size="small"
                                   icon="el-icon-delete">Delete
                        </el-button>
                        <el-button @click="handleBatchMove" :disabled="!selectionIds.length" type="primary" size="small"
                                   icon="el-icon-rank">Move
                        </el-button>
                        <el-button @click="onSendSelected" :disabled="!selectionIds.length" type="primary" size="small"
                                   icon="el-icon-position">Send
                        </el-button>
                    </el-button-group>
                </div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
        <el-dialog title="Edit Subject" closeable :visible.sync="showDialog" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form label-width="140px" size="medium" width="400px">
                <el-form-item label="Subject">
                    <el-input v-model="report.subject"/>
                </el-form-item>
                <el-form-item label="Apply to the same owner">
                    <el-switch v-model="apply_to_same_owner" active-value="yes" inactive-value="no"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">Submit</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <dialog-upload-report :dir="$route.query.dir||0" v-model="showUploader" @complete="onUploaded"/>
        <dialog-edit-directory :default-value="dir" v-model="showDirDialog" @saved="fetchList"/>
        <dialog-move-to-dir v-model="showMoveDialog" @move="onMoveFiles"/>
        <modal-send-mail ref="sendMail" @send="onSend"/>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";
import DialogUploadReport from "./files/DialogUploadReport";
import DialogEditDirectory from "./files/DialogEditDirectory";
import DialogMoveToDir from "./files/DialogMoveToDir";
import ModalSendMail from "../components/ModalSendMail.vue";

let interval = null;
export default {
    name: "AssociationFiles",
    components: {ModalSendMail, DialogMoveToDir, DialogEditDirectory, DialogUploadReport},
    mixins: [Pagination],
    data() {
        return {
            pageSize: 20,
            showUploader: false,
            action: '',
            showDialog: false,
            taskList: [],
            taskRunning: false,
            report: {},
            apply_to_same_owner: 'yes',
            owner: {},
            showOwner: false,
            onSend: () => {

            },
            params: {
                q: '',
                email_status: '',
                dir: 0,
                orderby: 'name',
                order: 'asc'
            },
            showDirDialog: false,
            dir: {
                id: 0,
                name: null,
                parent_id: null,
                description: null,
            },
            curDir: {},
            curDirPaths: [],
            showMoveDialog: false,
            selectedFileIds: []
        }
    },
    methods: {
        listApi() {
            return '/buildium/associations/files'
        },
        listParams() {
            return this.params;
        },
        onUploaded() {
            this.showUploader = false;
            this.fetchList();
        },
        onBatchDelete() {
            let {selectionIds} = this;
            if (selectionIds.length) {
                let ids = selectionIds.map(item => item.id);
                this.$confirm('Are you sure to delete selected items?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    ApiService.delete('/buildium/associations/files/batch', {data: {ids}}).then(response => {
                        this.$message.success('Deleted successfully');
                        this.fetchList();
                    }).catch(reason => {
                        this.$message.error(reason.message);
                    });
                }).catch(() => {
                    //this.$message.info('Canceled');
                });
            } else {
                this.$message.warning('Please select items to delete');
            }
        },
        onEdit(r) {
            this.report = r;
            this.showDialog = true;
        },
        onSubmit() {
            let {report, apply_to_same_owner} = this;
            ApiService.put('/buildium/associations/files/' + report.id, {
                subject: report.subject,
                apply_to_same_owner
            }).then(response => {
                this.showDialog = false;
                this.$message.success('Updated successfully');
                this.fetchList();
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {

            });
        },
        handleShowEditOwner(o) {
            this.owner = {...o};
            this.showOwner = true;
        },
        handleShowAddOwner(fileId) {
            this.owner = {
                Email: null,
                AlternateEmail: null,
                FirstName: null,
                LastName: null,
                Type: 'Custom',
                reports: [fileId]
            };
            this.showOwner = true;
        },
        onOwnerUpdated() {
            this.showOwner = false;
            this.fetchList();
        },
        formatOwnerName(o) {
            let str = '';
            if (o.FirstName) {
                str += o.FirstName;
            }

            if (o.LastName) {
                str += ' ' + o.LastName;
            }
            return str;
        },
        onSendAll() {
            this.$refs.sendMail.open();
            this.onSend = (options) => {
                this.sendReports('all', options, 'no');
            }
        },
        onResend(r) {
            this.$refs.sendMail.open();
            this.onSend = (options) => {
                this.sendReports([r.id], options, 'yes');
            }
        },
        onSendSelected() {
            this.$refs.sendMail.open();
            this.onSend = (options) => {
                this.sendReports(this.selectionIds.map(item => item.id), options, 'no');
            }
        },
        sendReports(ids, options, sync) {
            this.showMailer = false;
            this.loading = true;
            ApiService.post('/buildium/associations/files/send', {
                ids,
                options,
                sync
            }).then(response => {
                this.$message.success('Sent successfully');
                this.fetchList();
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        handleAddDir() {
            const dir_id = this.$route.query.dir || 0;
            this.dir = {
                id: 0,
                dir_id,
                name: null,
                description: null
            };
            this.showDirDialog = true;
        },
        handleEditDir(d) {
            this.dir = d;
            this.showDirDialog = true;
        },
        handleDeleteDir(d) {
            this.$confirm('Are you sure to delete this directory?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                ApiService.delete('/buildium/associations/dirs/' + d.id).then(response => {
                    this.$message.success('Deleted successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            }).catch(() => {
                //this.$message.info('Canceled');
            });
        },
        handleMoveDir(d) {
            this.selectedFileIds = [d.id];
            this.showMoveDialog = true;
        },
        handleDownloadDir(d) {
            window.open(d.links.download.href);
        },
        handleExportDir(d) {
            window.open(d.links.export.href);
        },
        handleBatchMove() {
            this.selectedFileIds = this.selectionIds.map(item => item.id);
            this.showMoveDialog = true;
        },
        onMoveFiles(dir) {
            ApiService.post('/buildium/associations/files/move', {
                target: dir,
                files: this.selectedFileIds
            }).then(response => {
                this.$message.success('Moved successfully');
                this.$router.push({path: '/buildium/association-files', query: {dir}});
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        onSortChange(e) {
            //console.log(e);
            this.params.orderby = e.prop;
            this.params.order = e.order === 'ascending' ? 'asc' : 'desc';
            this.fetchList();
        },
        getFirstOwner(owners) {
            if (owners && owners[0]) {
                return owners[0].FirstName + ' ' + owners[0].LastName + '<' + owners[0].Email + '>';
            }

            return '';
        }
    },
    mounted() {
        const {dir} = this.$route.query;
        if (dir) {
            this.params.dir = dir;
            ApiService.get('/buildium/associations/dirs/' + dir).then(response => {
                this.curDir = response.data.dir;
                this.curDirPaths = response.data.paths;
            });
        }

        this.fetchList();
        interval = setInterval(() => {
            if (this.showMailer) {
                return false;
            }
            this.fetchList();
        }, 50000);
    },
    beforeDestroy() {
        //console.log('beforeDestroy');
        clearInterval(interval);
    }
}
</script>

<style scoped>

</style>